import { Route, Switch } from "react-router-dom";
import { Component, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { metadataSuccess } from "app-component/slices/metadata-slice";

import { checkFeatureAccess } from "utils/role-restriction/helper";
import { LiveClassesRoutes } from "./routes";

export interface IMatch {
  url: string;
}

export default function LiveClassesPage({ match }: { match: IMatch }) {
  const [showLoading, setShowLoading] = useState(true);
  const limit= 1000;

  const { isLoading, data: metaData }: any = useAppSelector(
    (state) => state.metadataReducer
  );

  const { profileData } = useAppSelector((state) => state.gmailLoginReducer);
  const userRoleStr = profileData?.role;
  const userRole = userRoleStr?.split(",") || [];
  const dispatch = useAppDispatch();
  
  const updateMetaData = (listData, metaKey) => {
    let metadataList = { ...metaData };
    metadataList[metaKey] = listData;
    dispatch(metadataSuccess(metadataList));
    setShowLoading(false);
  };

  const updateMetaDataMulti = (listData, metaKey, listData2, metaKey2, listData3, metaKey3, listData4, metaKey4, listData5,metaKey5, listData6, metaKey6, listData7, metaKey7, listData8, metaKey8, listData9, metaKey9, listData10, metaKey10, listData11, metaKey11, listData12, metaKey12, listData13, metaKey13, listData14, metaKey14, listData15, metaKey15, listData16, metaKey16) => {
    let metadataList = { ...metaData };
    metadataList[metaKey] = listData;
    metadataList[metaKey2] = listData2;
    metadataList[metaKey3] = listData3;
    metadataList[metaKey4] = listData4;
    metadataList[metaKey5] = listData5;
    metadataList[metaKey6] = listData6;
    metadataList[metaKey7] = listData7;
    metadataList[metaKey8] = listData8;
    metadataList[metaKey9] = listData9;
    metadataList[metaKey10] = listData10;
    metadataList[metaKey11] = listData11;
    metadataList[metaKey12] = listData12;
    metadataList[metaKey13] = listData13;
    metadataList[metaKey14] = listData14;
    metadataList[metaKey15] = listData15;
    metadataList[metaKey16] = listData16;
    dispatch(metadataSuccess(metadataList));
    setShowLoading(false);
  };

  useEffect(() => {
    setShowLoading(false);
  }, []);

  if (showLoading) return <p>Loading...</p>;
  
  return (
    <>
    <Switch>
      {LiveClassesRoutes.map((route, i) => {
        return (
          checkFeatureAccess(userRole, route.user) && (
            <Route
              key={i}
              exact
              path={`${match.url}${route.path}`}
              component={route.component}
            />
          )
        );
      })}
    </Switch>
    </>
  );
}
